/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconArrowUpLongBold extends React.Component {
  render() {
    const iconClasses = classNames(
      "icon arrow-up-long-bold",
      this.props.className
    );
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 15.035156 1.9628906 C 14.779406 1.9628906 14.523625 2.0623125 14.328125 2.2578125 L 7.2578125 9.328125 C 7.0668125 9.519125 6.9648438 9.7751563 6.9648438 10.035156 C 6.9648437 10.164156 6.9870625 10.293969 7.0390625 10.417969 C 7.1930625 10.791969 7.5608438 11.035156 7.9648438 11.035156 L 12.035156 11.035156 L 12.035156 26.035156 C 12.035156 27.140156 12.930156 28.035156 14.035156 28.035156 L 16.035156 28.035156 C 17.140156 28.035156 18.035156 27.140156 18.035156 26.035156 L 18.035156 11.035156 L 22.105469 11.035156 C 22.509469 11.035156 22.875297 10.791969 23.029297 10.417969 C 23.185297 10.043969 23.0985 9.615125 22.8125 9.328125 L 15.742188 2.2578125 C 15.546688 2.0623125 15.290906 1.9628906 15.035156 1.9628906 z" />
      </svg>
    );
  }
}

IconArrowUpLongBold.defaultProps = {
  className: null
};

IconArrowUpLongBold.propTypes = {
  className: PropTypes.string
};

export default IconArrowUpLongBold;
